<template>
  <div class="inviteBox">
    <div class="info" v-if="price">
      <p class="title">推荐赚¥{{ price }}</p>
      <p class="tip">推荐好友购买后，即可赚邀请奖励金（可提现）</p>
    </div>
    <div class="main">
      <div class="user">
        <img :src="userInfo.headerimg" alt="" />
        <p>我是{{ userInfo.nickname }},邀请你一起来学习!</p>
      </div>
      <div class="bg">
        <img :src="poster.pic" alt="" />
      </div>
      <div class="code">
        <div class="codeBox">
          <img v-if="src" :src="src" alt />
        </div>
        <div :style="{ display: 'none' }">
          <QrcodeVue
            :value="captcha"
            level="H"
            v-show="captcha"
            size="80"
          ></QrcodeVue>
        </div>
      </div>
    </div>
    <div class="opation" @click="util.shareBox()">邀请好友</div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  metaInfo() {
    return {
      title: "学习邀请卡",
    };
  },
  data() {
    return {
      userInfo: "",
      poster: "",
      src: "",
      captcha: "",
      price:''
    };
  },
  components: { QrcodeVue },
  created () {
     this.userInfo = this.$store.state.state.userinfo? JSON.parse(JSON.stringify(this.$store.state.state.userinfo)): "";
     this.price=this.$route.query.price?this.$route.query.price:'';
  },
  mounted() {
   
    this.getPoster();
  },
  methods: {
    getPoster() {
      var obj = {};
      this.$post(
        "/iart-api-crm/api/crm/platformposter/queryBySharePosterInfo",
        obj
      ).then((res) => {
        if (res.code == 1) {
          this.poster = res.data;
          this.captcha =
            this.$store.state.state.shareUrl +
            "/h5/mine/recommend/recommend?img=" +
            this.userInfo.headerimg +
            "&name=" +
            this.userInfo.nickname;
          this.canvasToImg();
          this.shareLink();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    canvasToImg() {
      var _this = this;
      var Canvas = document.getElementsByTagName("canvas")[0];
      this.src = Canvas.toDataURL("image/png");
    },
    shareLink() {
      var _this = this;
      var url =
        this.$store.state.state.shareUrl +
        "/h5/mine/recommend/recommend?img=" +
        this.userInfo.headerimg +
        "&name=" +
        this.userInfo.nickname;
      var data = {
        title: this.poster.sharetitle,
        desc: this.poster.signature ? this.poster.signature : "", // 分享描述
        url: url,
        imgUrl: this.poster.shareicon,
      };
      this.util.shareLink( data).then(function () {});
    },
  },
};
</script>

<style lang="scss" scoped>
.inviteBox {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #fff;
  padding: 16px;
  overflow: auto;
  .info {
    margin-bottom: 20px;
    .title {
      font-size: 18px;
      line-height: 25px;
      color: rgba(51, 51, 51, 1);
      font-weight: bold;
    }
    .tip {
      font-size: 12px;
      line-height: 17px;
      color: rgba(153, 153, 153, 1);
      margin-top: 4px;
    }
  }
  .main {
    border-radius: 4px;
    position: relative;
    min-height: 500;
    .user {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: absolute;
      left: 20px;
      top: 20px;
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      p {
        margin-left: 12px;
        font-size: 14px;
        line-height: 27px;
        color: rgba(51, 51, 51, 1);
      }
    }
    .code {
      position: absolute;
      bottom: 20px;
      left: 0;
      right: 0;
      text-align: center;
      .codeBox {
        display: inline-block;
        padding: 10px;
        background: #fff;
      }
      img {
        width: 80px;
        height: 80px;
      }
    }
  }
  .opation {
    margin-top: 20px;
    font-size: 16px;
    line-height: 22px;
    color: rgba(102, 102, 102, 1);
    padding: 13px;
    border: 0.5px solid rgba(204, 204, 204, 1);
    border-radius: 5px;
    text-align: center;
  }
}
</style>